import React from "react";

import { ToggleTabsStyled } from "./toggleTabs.styles";

const ToggleTabs = ({ getTab, setTab, small, children, location, ...rest }) => {
  //   const [getTab, setgetTab] = useState(0);

  const handle_toggleTabsStyled_click = (e) => {
    const clicked = e.target.dataset.n;
    setTab(clicked);
  };

  return (
    <ToggleTabsStyled
      active={getTab}
      onClick={handle_toggleTabsStyled_click}
      small={small}
      {...rest}
    >
      {children}
    </ToggleTabsStyled>
  );
};

export default ToggleTabs;
